import { render, staticRenderFns } from "./djgzDetail.vue?vue&type=template&id=3052b63b&scoped=true"
import script from "./djgzDetail.vue?vue&type=script&lang=js"
export * from "./djgzDetail.vue?vue&type=script&lang=js"
import style0 from "./djgzDetail.vue?vue&type=style&index=0&id=3052b63b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3052b63b",
  null
  
)

export default component.exports